import { useEffect, useState } from 'react';

// Lock local para bloquear INSTANTANEAMENTE no clique (mesmo frame),
// sem esperar o re-render do pai setar pendingAction.
const useLeadCardPending = (pendingAction) => {
  const [localPending, setLocalPending] = useState(false);

  const isPending = !!pendingAction || localPending;

  // Quando o pai limpa pendingAction (data mudou → useEffect no pai limpa tudo),
  // também limpa o lock local para desbloquear as ações.
  useEffect(() => {
    if (!pendingAction) setLocalPending(false);
  }, [pendingAction]);

  const fireAction = (actionFn) => () => {
    if (isPending) return;
    setLocalPending(true);
    actionFn();
  };

  const stop = (handler) => (e) => {
    e.stopPropagation();
    handler();
  };

  return { isPending, fireAction, stop };
};

export default useLeadCardPending;
